(function () {
  const root = document.querySelector('[data-shp-root]');
  if (!root) return;

  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveal (premium but light)
  const revealEls = Array.from(root.querySelectorAll('[data-reveal]'));
  if (!reduceMotion && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          e.target.classList.add('is-inview');
          io.unobserve(e.target);
        }
      }
    }, { threshold: 0.12 });
    revealEls.forEach(el => io.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('is-inview'));
  }

  // Deck controller per section
  const decks = Array.from(root.querySelectorAll('[data-shp-deck]'));

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function smoothBehavior() {
    return reduceMotion ? 'auto' : 'smooth';
  }

  decks.forEach((deck) => {
    const tabsScroller = deck.querySelector('[data-shp-tabs-scroller]');
    const indicator = deck.querySelector('[data-shp-indicator]');
    const tabButtons = Array.from(deck.querySelectorAll('[data-shp-tab]'));
    const slider = deck.querySelector('[data-shp-slider]');
    const slides = Array.from(deck.querySelectorAll('[data-shp-slide]'));

    const side = deck.querySelector('[data-shp-side]');
    const sideFrame = side ? side.querySelector('.shp-side__frame') : null;
    const imgA = side ? side.querySelector('[data-shp-side-img="a"]') : null;
    const imgB = side ? side.querySelector('[data-shp-side-img="b"]') : null;
    let sideLayer = 0;

    if (!tabButtons.length || !slider || !slides.length || !indicator) return;

    function setIndicatorToButton(btn) {
      if (!btn) return;
      const x = btn.offsetLeft;
      const w = btn.offsetWidth;
      indicator.style.transform = `translateX(${x}px)`;
      indicator.style.width = `${w}px`;
    }

    function scrollTabIntoView(btn) {
      if (!tabsScroller || !btn) return;
      const left = btn.offsetLeft - (tabsScroller.clientWidth / 2) + (btn.offsetWidth / 2);
      tabsScroller.scrollTo({ left, behavior: smoothBehavior() });
    }

    function setSideImage(url, alt) {
      if (!imgA || !imgB) return;

      // IMPORTANT: if no image URL, hide both layers so we don't show a stale image
      if (!url) {
        imgA.classList.remove('is-on');
        imgB.classList.remove('is-on');
        return;
      }

      const next = sideLayer === 0 ? imgB : imgA;
      const prev = sideLayer === 0 ? imgA : imgB;

      next.alt = alt || '';
      next.src = url;

      // Crossfade
      next.classList.add('is-on');
      prev.classList.remove('is-on');

      sideLayer = sideLayer === 0 ? 1 : 0;
    }

    function setSideLabel(text) {
      if (!sideFrame) return;
      const t = (text || '').trim();
      if (t) sideFrame.setAttribute('data-label', t);
      else sideFrame.removeAttribute('data-label');
    }

    function setActive(index, opts = {}) {
      const i = clamp(index, 0, tabButtons.length - 1);

      tabButtons.forEach((b, bi) => b.classList.toggle('is-active', bi === i));
      slides.forEach((s, si) => s.classList.toggle('is-active', si === i));

      const btn = tabButtons[i];
      setIndicatorToButton(btn);

      if (opts.scrollTabs) scrollTabIntoView(btn);

      if (opts.scrollSlider) {
        const targetSlide = slides[i];
        // Use scrollIntoView for predictable snap
        targetSlide.scrollIntoView({ behavior: smoothBehavior(), inline: 'start', block: 'nearest' });
      }

      const activeSlide = slides[i];
      const img = activeSlide.getAttribute('data-img') || '';
      const alt = activeSlide.getAttribute('data-img-alt') || '';
      setSideImage(img, alt);

      // Side label (ties image to active subcategory)
      setSideLabel(btn ? btn.textContent : '');
    }

    // Init
    setActive(0, { scrollTabs: false, scrollSlider: false });

    tabButtons.forEach((btn, i) => {
      btn.addEventListener('click', () => setActive(i, { scrollTabs: true, scrollSlider: true }));
    });

    // Sync active tab when swiping deck (IntersectionObserver on slides)
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        // pick the most visible slide
        let best = null;
        for (const e of entries) {
          if (e.isIntersecting) {
            if (!best || e.intersectionRatio > best.intersectionRatio) best = e;
          }
        }
        if (best) {
          const idx = parseInt(best.target.getAttribute('data-index') || '0', 10);
          setActive(idx, { scrollTabs: false, scrollSlider: false });
        }
      }, { root: slider, threshold: [0.55, 0.66, 0.75] });

      slides.forEach(s => io.observe(s));
    } else {
      // Fallback: compute nearest slide on scroll end-ish
      let t = null;
      slider.addEventListener('scroll', () => {
        window.clearTimeout(t);
        t = window.setTimeout(() => {
          let bestIdx = 0;
          let bestDist = Infinity;
          const left = slider.scrollLeft;

          slides.forEach((s, idx) => {
            const d = Math.abs(s.offsetLeft - left);
            if (d < bestDist) {
              bestDist = d;
              bestIdx = idx;
            }
          });

          setActive(bestIdx, { scrollTabs: false, scrollSlider: false });
        }, 80);
      }, { passive: true });
    }

    // Re-position indicator on resize (and after load/fonts)
    function refreshIndicator() {
      const activeBtn = tabButtons.find(b => b.classList.contains('is-active')) || tabButtons[0];
      setIndicatorToButton(activeBtn);
    }

    window.addEventListener('resize', refreshIndicator);
    window.addEventListener('load', refreshIndicator);
  });
})();
